@use "../../variables" as *;

.colors-container {
  margin-top: 2rem;
  margin-bottom: 2rem;

  &.mobile {
    margin-bottom: 3.25rem;

    .headline {
      margin-left: 1.25rem;
      margin-bottom: 0.75rem;
      font-size: 1.25rem;
      line-height: 1.25rem;
      color: $grey-text;
    }

    .slider {
      display: flex;
      flex-direction: row;
      overflow-x: scroll;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;
      align-items: center;

      > div {
        &:first-child {
          margin-left: 0;
          padding-left: 1.25rem;
        }

        &:last-child {
          margin-right: 0;
          padding-right: 1.25rem;
        }
      }

      .color-container {
        flex: 1 0 auto;
        width: 40%;
        max-width: 40%;
        height: 100%;
        margin: 0 0.5rem 1rem 0.25rem;

        .color {
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: $white-bis;

          &.selected {
            border: 0.3px solid rgb(226,226,226);
            box-shadow: 0 0.125rem 0.5rem 1px rgba(0, 0, 0, 0.2);
          }

          .image-container {
            position: relative;
          }
        }
      }
    }
  }

  &.desktop {
    display: flex;
    justify-content: space-between;

    .colors {
      display: flex;
      max-width: 50%;
      flex-wrap: wrap;

      .color-container {
        padding: 2px;
        border: 1px solid $white;

        &.selected {
          border-color: #888888;
        }

        .color {
          width: 1.25rem;
          height: 1.25rem;
          border: 1px solid $grey-lighter;
          max-width: none;
          cursor: pointer;

          .thumbnail-img {
            height: auto;
            width: 100%;
          }
        }
      }
    }

    .color-name {
      font-size: 0.875rem;
      font-weight: 300;
      line-height: 0.875rem;
      color: $grey;
      max-width: 50%;
    }
  }
}
